import { getAddToCartPayload } from '../../../../helpers/getAddToCartPayload';
import { Cart, ProductBuilderMachineContext } from '../../../../types';

type AddToCartDev = (
  context: ProductBuilderMachineContext,
) => Promise<Partial<Cart>>;

export const addToCartDev: AddToCartDev = context => {
  const payload = getAddToCartPayload(context);
  console.log(`Payload: `, payload);
  return new Promise(resolve => {
    return setTimeout(() => {
      return resolve({ items: payload.items });
    }, 500);
  });
};
